export default {
  myCourses: [],
  loadingMyCourses: false,
  libraryCourses: [],
  loadingLibraryCourses: false,
  currentCourse: null,
  loadingCurrentCourse: false,
  currentCourseParticipants: [],
  loadingCurrentCourseParticipants: false,
  currentCourseAssignmentStatus: null,
  currentCourseSteps: [],
  loadingCurrentCourseSteps: false,
  currentCourseStep: null,
  loadingCurrentCourseStep: false,
}
